module.exports = __webpack_public_path__ + "img/nav-right-with-contact-infiniti.f799e961.png";